/* eslint-disable */
import type { ResponseContext } from "./ResponseContextProto.pb";
import type { ScenarioPlan } from "./scenarios.pb";

export interface InitiatePasscodeResetResponse {
  response_context?: ResponseContext;
  status?: InitiatePasscodeResetResponseStatus;
  /**
   * ScenarioPlan contains info about screens to show the user to complete the scenario.
   * Deprecated in v2.18 in favor of ResponseContext.
   *
   * @deprecated
   */
  scenario_plan?: ScenarioPlan;
}

export enum InitiatePasscodeResetResponseStatus {
  INVALID = "INVALID",
  SUCCESS = "SUCCESS",
  /**
   * CONCURRENT_MODIFICATION - Concurrent modification is returned when the customer doesn't have a passcode to reset.
   * When this is returned, the client should refresh its profile.
   */
  CONCURRENT_MODIFICATION = "CONCURRENT_MODIFICATION",
}
